import React from 'react'
import DevicesList from './DevicesList'
import { NavLink } from 'react-router-dom'
import { ubiznewsEmail, ubiznewsFacebook, ubiznewsInstagram, ubiznewsLinkedIn, ubiznewsYoutube } from '../constants/links'
import { getYear } from 'date-fns'
import { contactLink, jobLink } from '../constants/endspoints'

const Footer = () => {
    return (
        <>
            <div className='bgcolor-footer text-white pt-4 d-md-block d-none mt-auto'>

                {/* devices */}
                <div className='py-2 container'>
                    <DevicesList/>
                </div>

                {/* Main Links */}
                <div className='container mt-4'>
                    <div className='row justify-content-between align-items-start'>

                        <div className=' col-lg-3 col-md-6 col-12 mt-3'>
                            <h4 className='fw-bold'>Services</h4>
                            <NavLink className='text-white d-block pb-1 fs-8s' to={jobLink}>Emplois et stages</NavLink>
                            <NavLink className='text-white d-block pb-1 fs-8s' to={contactLink}>Aide & contact</NavLink>
                        </div>

                        <div className=' col-lg-3 col-md-6 col-12 mt-3'>
                            <h4 className='fw-bold'>Infos légales</h4>
                            <div className='text-white d-block pb-1 fs-8s' to='#'>Gérer les cookies</div>
                            <div className='text-white d-block pb-1 fs-8s' to='#'>Mentions légales et crédits</div>
                            <div className='text-white d-block pb-1 fs-8s' to='#'>Conditions générales d’utilisation</div>
                            <div className='text-white d-block pb-1 fs-8s' to='#'>Accessibilité</div>
                            <div className='text-white d-block pb-1 fs-8s' to='#'>Plan du site</div>
                        </div>

                        <div className=' col-lg-3 col-md-6 col-12 mt-3'>
                            <h4 className='fw-bold'>Réseaux sociaux</h4>
                            <a href={ubiznewsFacebook} target='_BLANK' rel='noreferrer' className=' d-flex align-items-center pb-1 text-white'>
                                <i className='fa-brands fa-facebook-f fs-7s me-2 text-white'></i>
                                <span className='fs-8s'>Facebook</span>
                            </a>
                            <a href={ubiznewsInstagram} target='_BLANK' rel='noreferrer' className='text-white d-flex align-items-center pb-1'>
                                <i className='fa-brands text-white fa-instagram fs-7s me-2'></i>
                                <span className='fs-8s'>Instagram</span>
                            </a>
                            <a href={ubiznewsLinkedIn} target='_BLANK' rel='noreferrer' className='text-white d-flex align-items-center pb-1'>
                                <i className='text-white fa-brands fa-linkedin-in fs-7s me-2'></i>
                                <span className='fs-8s'>LinkedIn</span>
                            </a>
                            <a href={ubiznewsYoutube} target='_BLANK' rel='noreferrer' className='text-white d-flex align-items-center pb-1'>
                                <i className='text-white fa-brands fa-youtube fs-7s me-2'></i>
                                <span className='fs-8s'>YouTube</span>
                            </a>
                        </div>

                        <div className=' col-lg-3 col-md-6 col-12 mt-3'>
                            <h4 className='fw-bold'>Contact</h4>
                            <div className=' row justify-content-around align-items-center gx-1'>
                                <a href={'mailto:'+ubiznewsEmail} target='_BLANK' rel='noreferrer' className='text-white d-flex align-items-center pb-1'>
                                    <i className='text-white fa fa-envelope fs-7s me-2'></i>
                                    <span className='fs-8s'>{ubiznewsEmail}</span>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>

                {/* Design */}
                <div className=' py-2 mt-1 bg-image-footer'>
                    <div className='container h-100'>
                        <div className='w-100 h-100 d-flex justify-content-center align-items-end fs-7s text-white fw-medium'>
                            Tous droits de reproduction et de diffusion réservés © {getYear(Date.now())} UBIZNEWS
                        </div>
                    </div>
                </div>
            </div>
            <div className='d-md-none d-block py-2 mb-5 mt-auto'>
                <div className='w-100 h-100 mt-1 d-flex justify-content-center align-items-end fs-7s text-white fw-medium text-center text-opacity-75'>
                    Tous droits de reproduction et de diffusion réservés © {getYear(Date.now())} UBIZNEWS
                </div>
            </div>
        </>
    )
}

export default Footer